import deepFreeze from '../utilities/freeze';
export default deepFreeze({
    WINDOW: {
        CLICK_EVENT: 'body:click:event',
    },
    BODY: {
        TOGGLE_OVERLAY: 'toggle:overlay',
        ON_OVERLAY: 'on:overlay',
        OFF_OVERLAY: 'off:overlay',
    },
    HEADER: {
        UPDATE_TRAP: 'header:trap:update',
        IN_PDP: 'header:inPdp',
    },
    BURGER: {
        TOGGLE_MENU: 'menu:toggle',
    },
    BREAKPOINTER: {
        BREAKPOINT_CHANGE: 'breakpoint:change',
    },
    DROP_DOWN: {
        OPEN: 'dropdown:open',
        CLOSE: 'dropdown:close',
    },
    PRODUCT_CAROUSEL: {
        UPDATE_IMAGES: 'product:carousel:update_images',
        UPDATE_ZOOM_IMAGES: 'product:carousel:update_zoom_images',
    },
    BRANDS: {
        UPDATE_GRID: 'brands:update:grid',
        UPDATE_STORES: 'brands:update:stores',
        SEARCH_BY_STORE: 'brands:search:bystore',
    },
    MODAL_EVENTS: {
        show: 'modal:show',
        close: 'modal:close',
    },
});
